import React, { useState } from "react";
import {
  Col,
  Row,
  Modal,
  Form,
  Input,
  DatePicker,
  Select,
  Button,
  InputNumber,
} from "antd";
import { formatPhoneNumber } from "../../../../utils/formatters";

export const OnboardModal = ({
  visible,
  onFinish,
  genders,
  form,
  sectors,
  isLoading,
}) => {
  if (!visible) {
    return;
  }

  return (
    <Modal
      loading={isLoading}
      style={{ minWidth: 800 }}
      title="Son Bir Adım"
      open={visible}
      closable={false}
      footer={null}
      maskClosable={false}>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Row gutter={8}>
          <Col md={12} xs={24}>
            <Form.Item
              name="name"
              label="İsim"
              rules={[
                {
                  required: true,
                  message: "Lütfen zorunlu alanları doldurunuz!",
                },
              ]}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col md={12} xs={24}>
            <Form.Item
              name="surname"
              label="Soyisim"
              rules={[
                {
                  required: true,
                  message: "Lütfen zorunlu alanları doldurunuz!",
                },
              ]}>
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={8}>
          <Col md={12} xs={24}>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                {
                  required: true,
                  message: "Lütfen zorunlu alanları doldurunuz!",
                },
                { type: "email", message: "Lütfen geçerli bir email giriniz!" },
              ]}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Telefon"
              name="phoneNumber"
              rules={[
                {
                  required: true,
                  message: "Lütfen telefon numaranızı giriniz",
                },
              ]}>
              <InputNumber
                style={{ width: "100%" }}
                maxLength={12}
                placeholder="Telefon"
                addonBefore={"+90"}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={8}>
          <Col md={12} xs={24}>
            <Form.Item
              name="birthDate"
              label="Birth Date"
              rules={[
                {
                  required: true,
                  message: "Lütfen zorunlu alanları doldurunuz!",
                },
              ]}>
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col md={12} xs={24}>
            <Form.Item
              name="gender"
              label="Gender"
              rules={[
                {
                  required: true,
                  message: "Lütfen zorunlu alanları doldurunuz!",
                },
              ]}>
              <Select options={genders} placeholder="Cinsiyet"></Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={8}>
          <Col xs={24} md={12}>
            <Form.Item
              name="sectorIds"
              label="Çalışmak istediğin sektörler"
              rules={[
                {
                  required: true,
                  message: "Lütfen zorunlu alanları doldurunuz!",
                },
              ]}>
              <Select
                options={sectors}
                showSearch
                mode="multiple"
                placeholder="Çalışmak istediğiniz sektörleri seçiniz"></Select>
            </Form.Item>
          </Col>
          <Col md={12} xs={24}>
            <Form.Item
              name="birthPlace"
              label="Birth Place"
              rules={[
                {
                  required: true,
                  message: "Lütfen zorunlu alanları doldurunuz!",
                },
              ]}>
              <Input placeholder="Doğum Yeriniz" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="summary"
          label="Kendin Hakkında Özet"
          rules={[
            { required: true, message: "Lütfen zorunlu alanları doldurunuz!" },
          ]}>
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Kaydet
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
